module.exports = __webpack_public_path__ + "img/LanghamChicagoBanner.fc631cf3.jpg";